<template>
    <q-page-container>
        <router-view />
    </q-page-container>
</template>
